import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router';

Vue.use(VueRouter);
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/Home'
        },
        {
            path: "/Home",
            name: "خانه",
            component: () => import("./components/Home"),
        },
        {
            path: "/currentBag",
            name: "سبد خرید",
            component: () => import("./components/currentBag"),
        },
        {
            path: "/aboutUs",
            name: "درباره ما",
            component: () => import("./components/aboutUs"),
        },
        {
            path: "/contactUs",
            name: "تماس با ما",
            component: () => import( "./components/contactUs"),
        },
        {
            path: "/SuggestionCritic",
            name: "انتقادات و پیش نهادات",
            component: () => import("./components/SuggestionCritic"),
        },
        {
            path: "/registerUser",
            name: "ثبت نام",
            component: () => import("./components/registerUser"),
        },
        {
            path: "/publicly",
            name: "قوانین و مقررات",
            component: () => import("./components/publicly"),
        },

        {
            path: "/profile",
            name: "پروفایل",
            component: () => import("./components/profile"),
        },
        {
            path: "/OrderRecords",
            name: "سوابق سفارشات",
            component: () => import("./components/OrderRecords"),
        },
        {
            path: "/productDetail2",
            name: "جزئیات محصول",
            component: () => import( "./components/productDetail2"),
        },
        {
            path: "/productDetail1",
            name: "جزئیات محصول",
            component: () => import("./components/productDetail1"),
        },
        {
            path: "/vipMoreProducts",
            name: "محصولات ویژه",
            component: () => import("./components/vipMoreProducts"),
        },
        {
            path: "/selectedMoreProducts",
            name: "پرفروش ترین محصولات",
            component: () => import("./components/selectedMoreProducts"),
        },
        {
            path: "/categoryMoreProducts",
            name: "دسته بندی محصولات",
            component: () => import("./components/categoryMoreProducts"),
        },
        {
            path: "/brandsProducts",
            name: "برند محصولات",
            component: () => import("./components/brandsProducts"),
        },
        {
            path: "/search",
            name: "جستجو محصولات",
            component: ()=> import("./components/search"),
        },
        {
            path: "/categoryProducts",
            name: "محصولات دسته بندی",
            component: () => import("./components/categoryProducts"),
        },
        {
            path: "/allProducts",
            name: "همه محصولات",
            component: ()=> import("./components/allProducts"),
        },
        {
            path: "/BlogPosts",
            name: "دانستنی های انتشارات شاهکار قلم",
            component: ()=> import("./components/BlogPosts"),
        },
        {
            path: "/blogPostsDetails/:id/:title",
            name: "جزئیات مقاله",
            component: () => import("./components/BlogPostsDetails"),
        },
    ]
});
